import type { Practitioner, Reference } from '@medplum/fhirtypes'
import { cn, StarToggle } from '@seen/ui'
import { IconCheck } from '@tabler/icons-react'
import type { JSX } from 'react'
import { PractitionerNameplate } from '#src/components/nameplates/PractitionerNameplate.tsx'

export function PractitionerOption({
  practitioner,
  isSelected,
  faxNumber,
  isPreferred,
}: {
  practitioner: Reference<Practitioner>
  isSelected?: boolean
  faxNumber?: string
  isPreferred?: boolean
}): JSX.Element {
  return (
    <div className="flex flex-1 items-center justify-between gap-2">
      <span className="flex min-w-0 items-center">
        <PractitionerNameplate
          practitioner={practitioner}
          faxNumber={faxNumber}
        />
      </span>
      <span className="flex shrink-0 items-center gap-1.5">
        {isPreferred && <StarToggle active label="Preferred provider" />}
        <IconCheck
          className={cn('mr-0.5 size-4 opacity-0', isSelected && 'opacity-100')}
        />
      </span>
    </div>
  )
}
